import notify from '@/prototypes/notify.lang.en';

export default {
  ...notify,
};
